<script lang="ts" setup>
import DetailsItem from "@/components/Cards/Details/DetailsItem.vue";
import {computed, ref} from "vue";
import {useEntitiesStore} from "@/stores/entities.store.ts";
import {SyncState} from "@/domain/type/synchro.type.ts";
import type {CardData} from "@/domain/type/entity.type.ts";

const props = defineProps<{
  entityUuid: string,
  type: string,
  details: CardData[],
  link: string,
  status: SyncState,
  showError: boolean,
  showSideCar: boolean
  icon: string
}
>();

const loading = ref(false);

function openSource() {
  if (0 === props.link.length) {
    return;
  }
  window.open(props.link, '_blank');
}

function onReloadClick() {
  loading.value = true;
  useEntitiesStore().refreshEntity(props.entityUuid).finally(() => {
    loading.value = false;
  });
}

const error = computed(() => {
  switch (props.status) {
    case SyncState.MISSING:
      return 'Aucune correspondance trouvée.';
    case SyncState.TOO_MANY:
      return 'Plusieurs correspondances ont été trouvées.';
    case SyncState.OTHER_OWNER:
      return 'Trouvé dans une autre entreprise.';
    default:
      return undefined;
  }
});

</script>

<template>
  <div class="d-flex">
    <v-card :loading="loading" class="flex-grow-1" @click="openSource">
      <template v-slot:loader="{ isActive }">
        <v-progress-linear
          :active="isActive"
          color="blue"
          height="4"
          indeterminate
        />
      </template>
      <v-card-text>
        <v-icon class="float-end text-h4 pl-5" color="grey" :icon="icon" size="x-large"/>
        <details-item v-for="(detail) in details" :key="detail.label" :label="detail.label ?? ''" :value="detail.value ?? ''"/>
      </v-card-text>
      <v-overlay
        :model-value="showError && undefined !== error"
        :opacity="0.6"
        class="align-center justify-center"
        contained
      >
        <div class="d-flex flex-column">
          <span class="text-white font-weight-bold text-center pa-5"> {{ error }}</span>
        </div>
      </v-overlay>
    </v-card>
    <div v-show="showSideCar" class="card-sidecar bg-green-lighten-1">
      <v-icon v-tooltip="'Actualiser les données en provenance d\'Eva et Ammon'" class="reload-icon" color="white" icon="mdi-reload" size="13px" @click="onReloadClick()"/>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.card-sidecar {
  display: inline;
  padding: 2px;
  border-top-right-radius: 25%;
  border-bottom-right-radius: 25%;
  height: 30px;

  .reload-icon {
    cursor: pointer;
  }

}
</style>
